"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Map of type identifiers to user friendly names
 * @type {Object}
 */
var _default = {
  'note': 'Note',
  'attachment': 'Attachment',
  'book': 'Book',
  'bookSection': 'Book Section',
  'journalArticle': 'Journal Article',
  'magazineArticle': 'Magazine Article',
  'newspaperArticle': 'Newspaper Article',
  'thesis': 'Thesis',
  'letter': 'Letter',
  'manuscript': 'Manuscript',
  'interview': 'Interview',
  'film': 'Film',
  'artwork': 'Artwork',
  'webpage': 'Web Page',
  'report': 'Report',
  'bill': 'Bill',
  'case': 'Case',
  'hearing': 'Hearing',
  'patent': 'Patent',
  'statute': 'Statute',
  'email': 'E-mail',
  'map': 'Map',
  'blogPost': 'Blog Post',
  'instantMessage': 'Instant Message',
  'forumPost': 'Forum Post',
  'audioRecording': 'Audio Recording',
  'presentation': 'Presentation',
  'videoRecording': 'Video Recording',
  'tvBroadcast': 'TV Broadcast',
  'radioBroadcast': 'Radio Broadcast',
  'podcast': 'Podcast',
  'computerProgram': 'Computer Program',
  'conferencePaper': 'Conference Paper',
  'document': 'Document',
  'encyclopediaArticle': 'Encyclopedia Article',
  'dictionaryEntry': 'Dictionary Entry'
};
exports.default = _default;